(() => {
  const CFG_URL = window.NEXSTORE_CFG_URL || '/assets/nexstore.config.json';
  const API_URL = 'https://nexstore-license-server.vercel.app/api/validate-license';

  function setResult(ok, payload) {
    // Globale vlag (handig voor badges/overlays)
    window.NEXSTORE_LICENSE_OK = !!ok;

    // Zet/haal een attribuut op <html> (voor optionele CSS)
    const html = document.documentElement;
    if (ok) {
      html.removeAttribute('data-nexstore');
    } else {
      html.setAttribute('data-nexstore', 'bad');
    }

    // Event zodat je elders kunt luisteren
    try {
      window.dispatchEvent(
        new CustomEvent('nexstore:license', { detail: { ok: !!ok, payload } })
      );
    } catch {}

    if (!ok) {
      console.warn('[NexStore] license invalid or mismatch:', payload);
    }
  }

  async function run() {
    try {
      // 1) Config ophalen
      const resCfg = await fetch(CFG_URL, { cache: 'no-store' });
      if (!resCfg.ok) throw new Error('config missing');
      const cfg = await resCfg.json();

      // 2) Validate-call opbouwen
      const u = new URL(API_URL);
      u.searchParams.set('license_key', cfg.license_key || '');
      u.searchParams.set(
        'shop_domain',
        cfg.shop_domain || (window.Shopify && window.Shopify.shop) || ''
      );
      u.searchParams.set('site_url', cfg.site_url || window.location.origin);
      const themeId =
        window.Shopify &&
        window.Shopify.theme &&
        window.Shopify.theme.id
          ? String(window.Shopify.theme.id)
          : 'theme';
      u.searchParams.set('theme_id', themeId);
      if (cfg.signature) u.searchParams.set('sig', cfg.signature);

      // 3) Call doen
      const res = await fetch(u.toString(), { method: 'GET', cache: 'no-store' });
      const body = await res.json().catch(() => ({}));

      // 4) Resultaat verwerken
      if (res.ok && body && body.ok) {
        setResult(true, body);
      } else {
        setResult(false, body);
      }
    } catch (e) {
      console.warn('[NexStore] license check failed:', e);
      setResult(false, { error: 'fetch_failed', message: String(e && e.message || e) });
    }
  }

  // Start
  run();
})();
